window.AdvivaAnimations = {

    init() {

        let body = jQuery('body');

        body.animate({
            'opacity': 1,
        }, 500);
        
        this.animations();
    },

    animations() {
        let animationsConfig = {
            ".ap_featured-text .ap_featured-word": {
                initialDelay: 100,
                "enter": "ap-fadeIn",
                cascade: 100,
            },
        };

        let mediaQueryMobile = 1024;

        jQuery('body').on('advivapress.window.scroll', function () {
            for (let selector in animationsConfig) {
                let n = 1;
                $(selector).each(function (i, element) {
                    let enterAnimationClass = animationsConfig[selector]["enter"];
                    let cascade = animationsConfig[selector]["cascade"];
                    let initialAnimationDelay = animationsConfig[selector]["initialDelay"];
                    let onlyDesktop = animationsConfig[selector]["onlyDesktop"];
                    if (enterAnimationClass) {
                        if ($(element).isInViewport() === true && $(element).hasClass('ap-animated') === false) {
                            if (!onlyDesktop || onlyDesktop === true && window.innerWidth > mediaQueryMobile) {
                                if (cascade) {
                                    if (initialAnimationDelay) {
                                        $(element).css("animation-delay", initialAnimationDelay + cascade * n + 'ms');
                                        n = n + 1;
                                    } else {
                                        $(element).css("animation-delay", cascade * n + 'ms');
                                        n = n + 1;
                                    }
                                }
                                $(element).addClass(enterAnimationClass);
                                let duration = $(element).css('animation-duration');
                                duration = duration.split("s");
                                duration = duration[0] * 1000;
                                setTimeout(function(){
                                    $(element).addClass(' ap-animated');
                                }, duration);

                            }
                        }
                        if ($(element).isInViewport() === false && cascade) {
                            n = 1;
                        }
                    }
                });
            }
        }).on('advivapress.window.finalize', function () {
            for (let selector in animationsConfig) {
                // Finalize
                let n = 1;
                let finalizeAnimationClass = animationsConfig[selector]["finalize"];

                if (finalizeAnimationClass) {
                    let el_list = $(selector);
                    let enterAnimationReverse = animationsConfig[selector]["reverse"];
                    if (enterAnimationReverse) {
                        el_list = $($(selector).toArray().reverse());
                    }
                    el_list.each(function (i, element) {
                        let cascade = animationsConfig[selector]["cascade"];
                        let initialAnimationDelay = animationsConfig[selector]["initialDelay"];
                        let onlyDesktop = animationsConfig[selector]["onlyDesktop"];
                        if (finalizeAnimationClass) {
                            if ($(element).isInViewport() === true && $(element).hasClass('ap-animated') === false) {
                                if (!onlyDesktop || onlyDesktop === true && window.innerWidth > mediaQueryMobile) {
                                    if (cascade) {
                                        if (initialAnimationDelay) {
                                            $(element).css("animation-delay", initialAnimationDelay + cascade * n + 'ms');
                                            n = n + 1;
                                        } else {
                                            $(element).css("animation-delay", cascade * n + 'ms');
                                            n = n + 1;
                                        }
                                    }
                                    $(element).addClass(finalizeAnimationClass);
                                    let duration = $(element).css('animation-duration');
                                    duration = duration.split("s");
                                    duration = duration[0] * 1000;
                                    setTimeout(function(){
                                        $(element).addClass(' ap-animated');
                                    }, duration);
                                }
                            }
                            if ($(element).isInViewport() === false && cascade) {
                                n = 1;
                            }
                        }
                    });

                    // TODO complete callback
                    /*let finalizeAnimationComplete = animationsConfig[selector]["complete"];
                    if(finalizeAnimationComplete){
                        if(finalizeAnimationComplete === 'manageHeader'){
                            //window.adv_manageHeader(jQuery('#site-masthead'));
                        }
                    }*/

                }

                // Enter
                let enterAnimationClassEnter = animationsConfig[selector]["enter"];
                if (enterAnimationClassEnter) {
                    $(selector).each(function (i, element) {
                        if ($(element).isInViewport() === true) {
                            $(element).addClass('ap-animated');
                        }
                    });
                }
            }
        });
    },

};
 
